module.exports = __webpack_public_path__ + "static/media/m_12.19fab170.png";